import { useMemo, useState } from 'preact/hooks';
import { RATING_DESC } from '../../../../constants';
import './style.css';

const ThumbRating = ({ id, ratingScore, setRatingScore }) => {
  const [hoverRating, setHoverRating] = useState(0);

  const getColor = (number) => {
    if (hoverRating === number) {
      return '#36aff9';
    }
    if (!hoverRating && ratingScore === number) {
      return '#36aff9';
    }
    return '#6873A2';
  };

  const desc = useMemo(() => {
    if (hoverRating !== 0) {
      return RATING_DESC[hoverRating - 1];
    }
    return RATING_DESC[ratingScore - 1];
  }, [ratingScore, hoverRating]);

  return (
    <div className="rating">
      <div className="thumb-rating">
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ fill: getColor(5) }}
          onClick={() => setRatingScore(5, id)}
          onMouseEnter={() => setHoverRating(5)}
          onMouseLeave={() => setHoverRating(0)}
        >
          <g clip-path="url(#clip0_5563_79427)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M22.1519 5.28877C22.5999 3.13337 21.2106 0.929931 19.1922 0.241825C18.1927 -0.124427 17.1495 -0.0377496 16.2944 0.256198C15.443 0.548882 14.6099 1.10454 14.0841 1.89166L14.0822 1.89447L10.0513 7.89159C9.88269 7.59156 9.66789 7.31205 9.39682 7.06183C8.47181 6.20797 7.2258 6.0127 6.05547 6.0127H4.55312C3.38279 6.0127 2.13678 6.20797 1.21177 7.06183C0.256333 7.94377 0 9.18945 0 10.4156V25.1387C0 26.3648 0.256333 27.6105 1.21177 28.4924C2.13678 29.3463 3.38279 29.5415 4.55312 29.5415H6.05547C7.2258 29.5415 8.4718 29.3463 9.39682 28.4924C9.65016 28.2585 9.85435 27.9991 10.0176 27.7213L12.8565 29.9191C13.4233 30.4445 14.1661 30.7401 14.7574 30.909C15.416 31.0972 16.1224 31.1939 16.7227 31.1939H22.4316C23.7042 31.1939 24.9574 30.7246 25.9563 29.9937C26.9412 29.273 27.7844 28.219 28.1251 26.9258L31.7092 16.0241C32.2289 14.5508 32.0518 13.0327 31.1899 11.8631C30.3315 10.698 28.9351 10.0689 27.3894 10.0689H21.407C21.4074 10.0607 21.4081 10.051 21.4096 10.0398L22.1519 5.28877ZM10.6086 24.2623L14.8937 27.5798L14.9631 27.6492C14.9673 27.6529 15.0145 27.6941 15.1334 27.7535C15.2554 27.8145 15.416 27.8764 15.6081 27.9313C16.0012 28.0436 16.4215 28.0971 16.7227 28.0971H22.4316C22.9619 28.0971 23.5866 27.8903 24.1276 27.4945C24.6675 27.0995 25.0154 26.5974 25.136 26.115L25.1497 26.0604L28.779 15.0211L28.7856 15.0026C29.0084 14.3788 28.8827 13.9524 28.6968 13.7001C28.5036 13.4379 28.0972 13.1657 27.3894 13.1657H21.38C19.5632 13.1657 18.0575 11.6064 18.3448 9.59546L18.3476 9.57538L19.1065 4.71915L19.1172 4.67101C19.2333 4.1488 18.8404 3.3888 18.1861 3.17068L18.1589 3.16161L18.132 3.15155C17.9379 3.07873 17.6401 3.06828 17.3011 3.18481C16.9517 3.30493 16.7341 3.49948 16.6589 3.61228L16.6556 3.61714L10.6086 12.614V24.2623ZM3.09682 10.4156C3.09682 9.53841 3.29119 9.35685 3.31228 9.33738C3.3638 9.28982 3.62015 9.10951 4.55312 9.10951H6.05547C6.98844 9.10951 7.24479 9.28982 7.29631 9.33738C7.3174 9.35685 7.51177 9.53841 7.51177 10.4156V25.1387C7.51177 26.0158 7.3174 26.1974 7.29631 26.2169C7.24479 26.2644 6.98844 26.4447 6.05547 26.4447H4.55312C3.62015 26.4447 3.3638 26.2644 3.31228 26.2169C3.29119 26.1974 3.09682 26.0158 3.09682 25.1387V10.4156Z"
            />
          </g>
          <defs>
            <clipPath id="clip0_5563_79427">
              <rect width="32" height="32" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ fill: getColor(1) }}
          onClick={() => setRatingScore(1, id)}
          onMouseEnter={() => setHoverRating(1)}
          onMouseLeave={() => setHoverRating(0)}
        >
          <g clip-path="url(#clip0_5563_79428)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.56888 0C8.29634 0 7.04313 0.46928 6.0442 1.20021C5.05926 1.92089 4.21606 2.97496 3.87544 4.26814L0.291333 15.1698C-0.228356 16.643 -0.0512679 18.1612 0.81057 19.3308C1.66903 20.4959 3.06543 21.125 4.61112 21.125H10.5935C10.5931 21.1332 10.5923 21.1429 10.5909 21.1541L9.84855 25.9051C9.40057 28.0605 10.7898 30.264 12.8083 30.9521C13.8078 31.3183 14.8509 31.2316 15.7061 30.9377C16.5576 30.645 17.3907 30.0893 17.9165 29.3021L17.9183 29.2994L21.9489 23.3026C22.1175 23.6026 22.3323 23.8821 22.6034 24.1322C23.5284 24.9861 24.7744 25.1814 25.9447 25.1814H27.4471C28.6174 25.1814 29.8634 24.9861 30.7884 24.1322C31.7438 23.2503 32.0002 22.0046 32.0002 20.7785V6.05546C32.0002 4.82934 31.7438 3.58366 30.7884 2.70172C29.8634 1.84786 28.6174 1.65259 27.4471 1.65259H25.9447C24.7744 1.65259 23.5284 1.84786 22.6034 2.70172C22.3501 2.9355 22.146 3.19483 21.9827 3.47258L19.144 1.27485C18.5772 0.749444 17.8344 0.453871 17.2431 0.284929C16.5845 0.0967581 15.8781 0 15.2778 0H9.56888ZM21.3916 6.93137L17.1068 3.6141L17.0374 3.54472C17.0332 3.54103 16.986 3.49984 16.867 3.44038C16.7451 3.37941 16.5845 3.31749 16.3923 3.26259C15.9993 3.15029 15.579 3.09681 15.2778 3.09681H9.56888C9.0386 3.09681 8.41387 3.30359 7.87289 3.69943C7.33302 4.09445 6.98507 4.5965 6.86447 5.07889L6.85082 5.13348L3.22146 16.1728L3.21485 16.1913C2.99208 16.8151 3.11778 17.2415 3.30367 17.4938C3.49686 17.756 3.90328 18.0282 4.61112 18.0282H10.6205C12.4372 18.0282 13.943 19.5875 13.6557 21.5984L13.6529 21.6185L12.8939 26.4747L12.8832 26.5229C12.7672 27.0451 13.16 27.8051 13.8144 28.0232L13.8416 28.0323L13.8684 28.0423C14.0626 28.1151 14.3603 28.1256 14.6993 28.0091C15.0488 27.8889 15.2664 27.6944 15.3416 27.5816L15.3448 27.5767L21.3916 18.5803V6.93137ZM24.4884 6.05546C24.4884 5.17829 24.6828 4.99673 24.7039 4.97727C24.7554 4.92971 25.0117 4.7494 25.9447 4.7494H27.4471C28.38 4.7494 28.6364 4.92971 28.6879 4.97727C28.709 4.99673 28.9034 5.17829 28.9034 6.05546V20.7785C28.9034 21.6557 28.709 21.8372 28.6879 21.8567C28.6364 21.9043 28.38 22.0846 27.4471 22.0846H25.9447C25.0117 22.0846 24.7554 21.9043 24.7039 21.8567C24.6828 21.8372 24.4884 21.6557 24.4884 20.7785V6.05546Z"
            />
          </g>
          <defs>
            <clipPath id="clip0_5563_79428">
              <rect width="32" height="32" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div className="description" id={id}>
        {desc}
      </div>
    </div>
  );
};

export default ThumbRating;
